exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Step2a-6ad36b4e{max-width:375px;margin:0 auto;text-align:center}.Step2a-6ad36b4e h3{margin-bottom:25px}.Step2a-6ad36b4e .formArea-c98aef59{max-width:240px;text-align:left;margin:0 auto}.Step2b-482319ba{max-width:400px;margin:0 auto}.Step2b-482319ba .numberInput-4c054d11{margin-top:30px}.Step2b-482319ba .error-8c095b26{color:#FF3940}\n", ""]);

// Exports
exports.locals = {
	"Step2a": "Step2a-6ad36b4e",
	"formArea": "formArea-c98aef59",
	"Step2b": "Step2b-482319ba",
	"numberInput": "numberInput-4c054d11",
	"error": "error-8c095b26"
};